(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("user", {
      template: require("./user.html"),
      controller: UserController
    });

  UserController.$inject = [
    "$scope",
    "$filter",
    "Messages",
    "alkAuthenticationService",
    "ALKChangePassword"
  ];

  function UserController($scope, $filter, Messages, alkAuthenticationService, ALKChangePassword) {
    let vm = this;

    vm.isProcessing = false;
    vm.loginInfo = {};

    vm.updateLogin = updateLogin;

    function updateLogin() {
      vm.isProcessing = true;
      Messages.clear();

      var changePassword = new ALKChangePassword(vm.loginInfo.existingPassword, vm.loginInfo.newPassword);

      alkAuthenticationService
        .changePassword(changePassword)
        .then(_onSuccess, _onError);
    }

    function _onSuccess() {
      vm.loginInfo = {};
      Messages.add("success", $filter("translate")("views.user.ChangePasswordSuccess"), {
        showOnNextPage: false
      });
      vm.isProcessing = false;
    }

    function _onError(err) {
      var errData = err.data;
      var message = $filter("translate")("views.user.ChangePasswordUnknownError");
      if (errData.reason === 1) {
        message = $filter("translate")("views.user.ChangePasswordFailedToLogin");
      }

      Messages.add("danger", message, {
        showOnNextPage: false
      });

      vm.isProcessing = false;
    }

    $scope.$on("$destroy", function () {
      Messages.clear();
    });

  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/auth/user.controller.js